import DropTablesNav from "./DropTablesNav";
import AdLayout from "../../app-core/AdLayout";
import LootGrid from "../LootGrid";
import * as T from "common/src/bindings/Translation2";

type Tables = Array<[number, Array<[string, number | undefined]>]>;

export default function HotnTables({
  tables: _,
}: {
  tables: { loot: Tables };
}) {
  const tables: any = [
    [0.1, [["Gold", 58]]],
    [0.1, [["Exp", 64]]],
    [0.1, [["Reroll", 40]]],
    [0.1, [["TFT_Consumable_RecommendedArmory"], ["Gold", 15], ["REMOVER"]]],
    [0.1, [["RNGolem"]]],
    [
      0.1,
      [["TFT_ArmoryKeyCompleted"], ["TFT_ArmoryKeyCompleted"], ["GoldenEgg"]],
    ],
    [
      0.1,
      [
        ["TFT_Consumable_RecommendedArmory"],
        ["TFT_Consumable_RecommendedArmory"],
        ["TFT_Consumable_RecommendedArmory"],
      ],
    ],
    [
      0.1,
      [
        ["TFT_ArmoryKeyComponent"],
        ["TFT_ArmoryKeyComponent"],
        ["TFT_Item_Spatula"],
        ["TFT_Item_FryingPan"],
      ],
    ],
    [
      0.1,
      [
        ["COMPONENT_NOSPAT"],
        ["COMPONENT_NOSPAT"],
        ["COMPONENT_NOSPAT"],
        ["COMPONENT_NOSPAT"],
        ["COMPONENT_NOSPAT"],
        ["COMPONENT_NOSPAT"],
      ],
    ],
    [
      0.1,
      [
        ["TFT_Item_ThiefsGloves"],
        ["TFT_Item_ThiefsGloves"],
        ["TFT_Item_ThiefsGloves"],
        ["REMOVER"],
      ],
    ],
  ];

  return (
    <AdLayout>
      <div className="flex flex-col bg-bg rounded w-full md:w-[928px] pb-4">
        <DropTablesNav route={"Call to Chaos"} />
        <h2 className="h2 p-4 pb-8 flex items-center gap-1">
          {T.augments("11Calltochaos")}
        </h2>
        <LootGrid data={tables} />
      </div>
    </AdLayout>
  );
}
